import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for WelcomeMessage component customisation
 * Returns main text and sub text styling and content
 */
export const useWelcomeMessageCustomisation = () => {
  const { getField: getMainTextField, isVisible: mainTextVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey: PUI.HOME_SECTION_KEYS.MAIN_TEXT,
    blockKey: PUI.HOME_BLOCK_KEYS.HEADER,
  });

  const { getField: getSubTextField, isVisible: subTextVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey: PUI.HOME_SECTION_KEYS.SUB_TEXT,
    blockKey: PUI.HOME_BLOCK_KEYS.HEADER,
  });

  const mainTextContent = getMainTextField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const mainTextColor = getMainTextField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const placeholderColor = getMainTextField(PUI.COMMON_FIELD_KEYS.HIGHLIGHT_COLOR);

  const subTextContent = getSubTextField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const subTextColor = getSubTextField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    mainTextVisible,
    subTextVisible,
    mainTextContent,
    mainTextColor,
    placeholderColor,
    subTextContent,
    subTextColor,
  };
};
